"use strict";

const BSMegaMenuInit = () => {
  let e = document.querySelectorAll(
    ".wp-block-navigation-item.is-style-gs-megamenufull"
  );

  e.forEach((element) => {
    element.addEventListener("mouseover", () => {
      document.body.classList.add("mega-menu-active");
    });

    element.addEventListener("mouseout", () => {
      document.body.classList.remove("mega-menu-active");
    });
  });

  for (let t = 0; t < e.length; t++) {
    let n = e[t],
      i = n.getBoundingClientRect(),
      l = i.y - i.height + 25;
    // l = i.y + i.height - 0.1;
    // l = headerParentHeight.clientHeight - 60;
    // console.log(i); // Print l in the console

    n.querySelector(".wp-block-navigation__submenu-container").style.top =
      l + "px";
  }

  // Recalculate when body has class zaza-sticky-active
  document.body.addEventListener("transitionend", () => {
    if (document.body.classList.contains("zaza-sticky-active")) {
      let stickyHeader = document.querySelector(".zaza-sticky-header");
      let headerHeight = stickyHeader.getBoundingClientRect().height;

      for (let t = 0; t < e.length; t++) {
        let n = e[t],
          i = n.getBoundingClientRect(),
          l = i.y - i.height + headerHeight;

        n.querySelector(".wp-block-navigation__submenu-container").style.top =
          l + "px";
      }
    } else {
      for (let t = 0; t < e.length; t++) {
        let n = e[t],
          i = n.getBoundingClientRect(),
          l = i.y - i.height + 25;

        n.querySelector(".wp-block-navigation__submenu-container").style.top =
          l + "px";
      }
    }
  });

  var headerHeightMenu = document.querySelector("header");
  let headerParentHeight = headerHeightMenu;
  headerParentHeight.clientHeight;

};
BSMegaMenuInit(), window.addEventListener("resize", BSMegaMenuInit);

